import type { Filter, FilterDataSwitch } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import { SearchModes } from '@/domainLogic/index.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { getTranslationServer } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

type CreateFlightFilters = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  translationDictionary: TranslationDictionary;
};
export const createFlightsFilters = ({
  searchParams,
  searchInfoData,
  translationDictionary,
}: CreateFlightFilters): Filter[] => {
  const { searchMode } = searchInfoData;

  const showFreeCancellation = searchMode !== SearchModes.HO && searchMode !== SearchModes.TH;
  const freeCancellationLabel = getTranslationServer(
    'vacation.oss.components.searchfilters.checkbox.direct',
    translationDictionary
  );
  const directFlightFilter: Filter | undefined = showFreeCancellation
    ? {
        name: FILTER_NAME.DIRECT_FLIGHT,
        type: FILTER_TYPE.SWITCH,
        data: {
          label: freeCancellationLabel,
          selected: searchParams?.[URLParameters.DIRECT] === '1',
          counter: undefined,
        } as FilterDataSwitch,
      }
    : undefined;

  return [...[directFlightFilter]].filter((f) => !!f);
};
